import axios from 'axios'

let localeLanguage = locale => {
  if (locale === 'en') {
    return '영어'
  }

  if (locale === 'ko') {
    return ' 한국어'
  }

  if (locale === 'jp') {
    return '일본어'
  }

  return '영어'
}

let requestReceipt = async params => {
  console.log('API requestReceipt', params)

  let data = {
    form_key: "fguQTw5I5H6zHSFDTIdcg",
    user: {
      username: "",
      email: params.email,
      phone_no: ''
    },
    field: {
      field_1: params.id,
      field_2: params.pw,
      field_3: params.name,
      field_4: params.hp,
      field_5: params.storePhoneNumber,
      field_6: params.deliveryName,
      field_7: params.deliveryAccountNumber,
      field_8: params.deliveryPhoneNumber,
      field_9: params.brImg,
      field_10: params.deliveryAgency.name,
      field_11: params.deliveryAgency.businessNum,
      field_12: params.deliveryAgency.contact
    }
  }

  console.log(data)

  try {
    let res = await axios({
      method: 'POST',
      url: `${process.env.VUE_APP_API_URL}/form`,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
    return res
  } catch (error) {
    console.log(error)
    return error
  }
}

let uploadImage = async frm => {
  console.log(frm)
  try {
    let res = await axios.post(`https://form.elixirpay.co.kr/admin/api/v1/image/upload`, frm, {
    // let res = await axios.post(`${process.env.VUE_APP_API_URL}/image`, frm, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    return res;
  } catch (error) {
    return error
  }
}

export {
  requestReceipt,
  uploadImage
}